import Components from "./components";
import {TradingViewService} from "./services/TradingViewService";
import {TradingViewQuoteFeedService} from "./services/TradingViewQuoteFeedService";
import {TvHistoryProvider} from "./services/TvHistoryProvider";

export default angular.module("tfApp.components.tradingView", [Components])
    .service(TradingViewService.id, TradingViewService)
    .service(TradingViewQuoteFeedService.id, TradingViewQuoteFeedService)
    .service(TvHistoryProvider.id, TvHistoryProvider)
    .name;
